import React from 'react';
import { Row, Col } from 'components';
import { EmailContent } from './emailContent';
import { LeadStatusChange } from './statusChange';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import styles from './styles.module.scss';
import { LeadBrands } from './brands';

export const LeadGeneral = React.memo(() => {
  return (
    <HasAccess role={PERMISSIONS.leads.lead.read}>
      <Row className={styles.generalContainer}>
        <Col span={24}>
          <HasAccess role={PERMISSIONS.leads.lead.write}>
            <LeadStatusChange />
          </HasAccess>
        </Col>
        <Col span={24} style={{ marginTop: 20 }}>
          <EmailContent />
        </Col>
        <Col span={24} style={{ marginTop: 20 }}>
          <HasAccess role={PERMISSIONS.brands.brand.read}>
            <LeadBrands />
          </HasAccess>
        </Col>
      </Row>
    </HasAccess>
  );
});
